import axiosInstance from "../../../../Shared/Utils/axiosInstance";
import { JurisdictionApi } from "../../../../Shared/Constants/api";
import { getJurisdictionCreationObject } from "../Data/JurisdictionWrappers";

export const createJurisdictionApi = async (data) => {
  try {
    let response = await axiosInstance.post(
      `${JurisdictionApi}`,
      getJurisdictionCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
